export const closestStoreData = (payload: any) => ({
  type: "CLOSEST_STORE_DATA",
  payload,
});
